import { jsx as _jsx } from "react/jsx-runtime";
var ArrowIosUp = function ArrowIosUp(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18 15a.995.995 0 0 1-.64-.232l-5.372-4.476-5.362 4.315a.999.999 0 1 1-1.253-1.558l6-4.828a.998.998 0 0 1 1.267.011l6 5A1 1 0 0 1 18 15Z",
      fill: color
    })
  });
};
export default ArrowIosUp;